import styles from './DatePicker.module.css';
import { FormattedMessage } from 'react-intl';
import { Input } from '../TextField/views';
import dayjs from 'dayjs';
import { setRange, useDateRangeValidation } from '../../services/reservations';

interface DatePickerProps {
  startDisabled?: boolean;
}

export const DatePicker = ({ startDisabled }: DatePickerProps) => {
  const {
    dateRange: [fromDatetime, toDatetime],
  } = useDateRangeValidation();

  return (
    <div className={styles.root}>
      <label htmlFor="reserve-start" className={styles.label}>
        <span>
          <FormattedMessage id="Date.Start" />:
        </span>
        <Input
          id="reserve-start"
          type="datetime-local"
          disabled={startDisabled}
          min={dayjs().format('YYYY-MM-DDTHH:mm')}
          className={styles.input}
          value={dayjs(fromDatetime).format('YYYY-MM-DDTHH:mm')}
          onChange={(e) =>
            setRange([
              e.target.value ? dayjs(e.target.value).toISOString() : '',
              toDatetime,
            ])
          }
        />
      </label>
      <label htmlFor="reserve-end" className={styles.label}>
        <span>
          <FormattedMessage id="Date.End" />:
        </span>
        <Input
          id="reserve-end"
          type="datetime-local"
          className={styles.input}
          min={dayjs().format('YYYY-MM-DDTHH:mm')}
          value={dayjs(toDatetime).format('YYYY-MM-DDTHH:mm')}
          onChange={(e) =>
            setRange([
              fromDatetime,
              e.target.value ? dayjs(e.target.value).toISOString() : '',
            ])
          }
        />
      </label>
    </div>
  );
};
